import axios from 'axios';
import {withAuthLogoutOn401} from "../utils/authTokens";

// New Knowledge Manager backend (topics/documents/queries/graph per the LightRAG OpenAPI spec).
// Kept separate from axios-rag.js so the legacy knowledge-manager pages (old server/host/port based
// backend) keep working against their own base URL untouched.
const instance = axios.create({
    baseURL: `${process.env.REACT_APP_KB_MANAGER_URL}`
});

// token on every request, refreshed/logged out on a 401; a 403 just shows a friendly message (see
// withAuthLogoutOn401) since the session is fine there, the Knowledge Manager is just denying the request
withAuthLogoutOn401(instance);

export const setKbManagerBaseURL = (url) => {
    instance.defaults.baseURL = url;
};

export default instance;
